import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import InvestorsTable from "./table"

const Investors = () => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"List"} breadcrumbItem={"List"} />
          <InvestorsTable />
        </Container>
      </div>
    </>
  )
}

export default Investors
